export enum AlertType {
	error,
	success,
	info,
	warning,
}

export interface Alert {
	message: string | null;
	alertType: AlertType;
	timeout?: boolean;
}
